import { createReducer } from '../../store.model';

import {
    ActionType,
    Reload,
    ReloadCancel,
    ReloadResult,
    ReloadUser,
    ReloadUserCancel,
    ReloadUserResult,
    SelectMetric,
} from './pillar-one.action';
import {
    categorizeOpportunities,
    checkMetricIdInMultiple,
    distillOpportunities,
    ensureSelectedIsOpen,
    findOpportunity,
} from './pillar-one.function';
import { defaultState, PillarOneState } from './pillar-one.state';

const { builder, reducer } = createReducer<ActionType, PillarOneState>(
    defaultState(),
);

builder.add<SelectMetric>(
    ActionType.COACHING_DETAIL__P1__SELECT_METRIC,
    (state, action) => {
        const metricId =
            action.payload.metricId == null || isNaN(action.payload.metricId)
                ? undefined
                : action.payload.metricId;
        const metricIdIsInMultiple = checkMetricIdInMultiple(
            metricId,
            state.commitmentGoalLookup,
        );
        const nonKpiId =
            action.payload.metricId != null && metricId != null
                ? undefined
                : action.payload.nonKpiId;

        const nextOppCategories = ensureSelectedIsOpen(
            state.oppCategories,
            metricId,
        );
        const nextOpp = findOpportunity(
            nextOppCategories,
            state.nonOpportunities,
            metricId,
        );

        return {
            ...state,
            metricId,
            opportunity: nextOpp,
            nonKpiId,
            metricIdIsInMultiple,
            oppCategories: nextOppCategories,
        };
    },
);

builder
    .add<Reload>(ActionType.COACHING_DETAIL__P1__RELOAD, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: true,
            },
        };
    })
    .add<ReloadResult>(
        ActionType.COACHING_DETAIL__P1__RELOAD_RESULT,
        (state, action) => {
            const opps = distillOpportunities(
                action.payload.performerOa.opportunities,
                action.payload.performerOa.nonKpis,
            );
            const { categories, nonOpportunitiesOpen, nonKpisOpen } =
                categorizeOpportunities(
                    opps,
                    action.payload.performerOa.activeNonOpportunityCommitments,
                    state.metricId,
                    action.payload.isNonKpi,
                );
            const nextNumOpportunities =
                opps.coached.length +
                opps.unCoached.length +
                opps.missed.length;

            const nextLookup =
                action.payload.performerOa.commitmentGoalMetricCount;
            const metricIdIsInMultiple = checkMetricIdInMultiple(
                state.metricId,
                nextLookup,
            );

            const nextOppCategories = ensureSelectedIsOpen(
                categories,
                state.metricId,
            );
            const nextOpp = findOpportunity(
                nextOppCategories,
                opps.nonOpportunities,
                state.metricId,
            );

            return {
                ...state,
                pending: {
                    ...state.pending,
                    reload: false,
                },
                opportunity: nextOpp,
                commitmentGoalLookup: nextLookup,
                metricIdIsInMultiple,
                numOpportunities: nextNumOpportunities,
                oppCategories: nextOppCategories,
                nonOpportunities: opps.nonOpportunities,
                nonOpportunitiesOpen,
                nonKpis: opps.nonKpis,
                nonKpisOpen,
            };
        },
    )
    .add<ReloadCancel>(
        ActionType.COACHING_DETAIL__P1__RELOAD_CANCEL,
        (state) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    reload: false,
                },
            };
        },
    );

builder
    .add<ReloadUser>(ActionType.COACHING_DETAIL__P1__RELOAD_USER, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                reloadUser: true,
            },
        };
    })
    .add<ReloadUserResult>(
        ActionType.COACHING_DETAIL__P1__RELOAD_USER_RESULT,
        (state, action) => {
            const nextUser = {
                id: null,
                name: null,
                superGroupName: null,
                managerName: null,
                email: null,
            };
            if (action.payload.user) {
                nextUser.id = action.payload.user.id;
                nextUser.name = `${action.payload.user.firstName} ${action.payload.user.lastName}`;
                nextUser.superGroupName = action.payload.user.superGroup;
                nextUser.email = action.payload.user.email;
            }
            if (action.payload.userManager) {
                nextUser.managerName = action.payload.userManager.managerName;
            }

            return {
                ...state,
                pending: {
                    ...state.pending,
                    reloadUser: false,
                },
                user: nextUser,
            };
        },
    )
    .add<ReloadUserCancel>(
        ActionType.COACHING_DETAIL__P1__RELOAD_USER_CANCEL,
        (state) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    reloadUser: false,
                },
            };
        },
    );

export const coachingDetailPillarOneReducer = reducer;
